import React from "react";
import { Oval } from "react-loader-spinner";
import InmateLogo from "../../../assets/logo/small.png";
import '../../../assets/css/Loader.css'; // Assuming the styles are moved into this CSS file
import loader from '../../../assets/svg/loader.svg';
import inmatelogo from '../../../assets/svg/inmate-logo.svg'

function CustomLoader() {
  return (



    <div className="loader-container vh-100 d-flex justify-content-center align-items-center">
      {/* <div className="icon-overlay position-relative">
        <img src={InmateLogo} alt="inmate-logo" />
      </div>
      <div className="position-absolute">
        <Oval
          className="position-absolute"
          height={70}
          width={70}
          color="#cc5a5a"
          ariaLabel="loading"
          stroke="red"
        />
      </div> */}
      <div>
        {/* Loader Background */}
        <div className="col-bg"></div>
        {/* Main Loader */}
        <div className="col-loader">
          <img src={loader} alt="Loading..." className="col-loader-03" />
          <img src={inmatelogo} alt="Inmate Logo" className="col-loader-image" />
        </div>

      </div>
    </div>
  );
}

export default CustomLoader;
